import styled from 'styled-components';
import {flexUnit} from '../../global-styles/mixins.js';

const StyledNumberCell = styled.div`
  position: relative;
  flex: 1 0 50%;
  max-width: 50%;
  &.is-column{
    flex: 1 0 100%;
    max-width: 100%;
  }
  &.number--cell-flex-is-image{
    flex: 1 0 40%;
    max-width: 40%;
  }
  .number--cell-flex{
    position:relative;
    width: 100%;
  }
  .number--size{
    ${flexUnit(5, 35, 54, 'vw', 'font-size')};
    line-height: 110%;
    letter-spacing: -.025em;
    font-family: 'Alliance No.2', sans-serif;
    font-weight: 400;
  }
  .number--cell-img{
    position: relative;
    width: 80%;
    margin-left: 0;
    margin-top: 40px;
    
  }
  .number--cell-img-mask{
    overflow: hidden;
    width: 100%;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    position: relative;
    display: block;
    width: 100%;
    z-index: 2;
  }
  .number--cell-img img{
    position: relative;
    display: block;
    width: 100%;
    z-index: 2;
  }
  .number--cell-img::after{
    content: '';
    position: absolute;
    background-color: #CCCCCC;
    opacity: 0.3;
    width: 100%;
    height: 100%;
    top: -40px;
    left: 40px;
    border-top-right-radius: 16px;
    border-top-left-radius: 16px;
    z-index: 1;
  }
  p{
    padding-right: 130px;
    margin-top: 32px; 
  }
  @media screen and (max-width: 1439px){
    p{
      padding-right: 80px 
    }
  }
  @media screen and (max-width: 1023px){
    p{
      padding-right: 50px;
      margin-top: 24px; 
    }
  }
  @media screen and (max-width: 767px){
    flex: 1 0 100%;
    max-width: 100%;
    width: 100%;
    padding: 0 24px;
    h2{
      margin-bottom: 8px;
    }
    p{
      padding: 0;
      margin-top: 16px; 
    }
    &.number--cell-flex-is-image{
      margin-bottom: 26px;
      flex: 1 0 50%;
      max-width: 100%;
      display: flex;
      justify-content: flex-end;
      .number--cell-flex {
        width: 50%;
      }
      .number--cell-img::after{
        content: '';
        position: absolute;
        background-color: #CDE4DC;
        opacity: 0.3;
        width: 100%;
        height: 100%;
        top: -20px;
        left: 20px;
        border-top-right-radius: 8px;
        border-top-left-radius: 8px;
        z-index: 1;
      }
    }
    &:nth-child(2){
      margin-bottom: 80px
    }
    .number--cell-img-mask{
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
    }
    &.is-column:nth-child(1){
      margin-bottom: 80px;
    }
  }
`;

export {
  StyledNumberCell,
};

